import { useEffect, useState } from "react";
import type { DashboardFilters, LaunchOption } from "../models/dashboard";
import { CommandGetLaunchesForFilter } from "../services/cmdGetLaunchesForFilter";
import { pickerParams } from "./dashboardFilters";

/**
 * The launches the picker offers (MPN-2230). The picker filters narrow them at once: each
 * change asks get-launches-for-filter again. They only narrow the choice. The chosen launch
 * is the URL's and stays whatever the pool says (MPN-2313): the old page swapped in the
 * server's default launch when the chosen one dropped out, or when none was chosen yet, so
 * the dashboard loaded a launch nobody picked, or none at all when the default pool was empty.
 */
export function useLaunchPool(filters: DashboardFilters) {
    const [launches, setLaunches] = useState<LaunchOption[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let live = true;
        setLoading(true);
        new CommandGetLaunchesForFilter().run(pickerParams(filters)).then((result) => {
            if (!live) return;
            setLaunches(result.launches ?? []);
            setLoading(false);
        }).catch(() => {
            if (!live) return;
            setLaunches([]);
            setLoading(false);
        });
        return () => { live = false; };
    }, [filters.revenue_type, filters.engagement_manager, filters.ops_manager]);

    return { launches, loading };
}
